import { get, cloneDeep } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';

import { TimeFormatType } from '../../common/components/TimeFormat/TimeFormat';

export const getSelectedChargers = createSelector(
  [(state) => cloneDeep(get(state, 'reports.powerMonitoring.chargers.selected', []))],
  (value) => value,
);

export const getLoadedChargers = createSelector(
  [(state) => cloneDeep(get(state, 'reports.powerMonitoring.chargers.loaded', []))],
  (value) => value,
);

export const getChargerMetrics = createSelector([(state) => get(state, 'reports.powerMonitoring.chargerMetrics', [])], (value) => value);

export const getTimeOffsetType = createSelector(
  [(state) => cloneDeep(get(state, 'reports.powerMonitoring.timeOffsetType', TimeFormatType.USER))],
  (value) => value,
);

/**
 *
 * @param state
 * @param reportName {string} "chargingSession" | "faults" | "deliveredEnergy"
 * @return {number}
 */
export const getReportMaxDateRange = createSelector(
  [(state, reportName) => get(state, `appConfig.config.reports.${reportName}.maxRange`, 60)],
  (value) => (value < 7 || value > 180 ? 60 : value),
);

export const selectActiveCustomerId = (state) =>
  get(state, 'form.reportFilterForm.values.customerId') ?? get(state, 'form.plazaReport.values.customerId') ?? null;

/** Returns the value of a field in the specified redux-form. */
export const selectFormFieldValue = (state, formName, fieldName) => get(state, `form.${formName}.values.${fieldName}`, '');
